@if ((tableModel$ | async); as tableModel) {
  <p-table [scTableSettings]="tableModel.tableSettings"
           class="mt-3">
    @if (!tableModel.isReadonly) {
      <ng-template pTemplate="tools-panel-right">
        <p-button label="Create new chapter"
                  i18n-label
                  (onClick)="newChapterDialog()"
                  styleClass="p-button-outlined">
        </p-button>
      </ng-template>
    }
    @if (!tableModel.isReadonly; as rowData) {
      <ng-template pTemplate="row-actions"
                   let-rowData>
        <p-button [disabled]="rowData.hasPapers"
                  icon="fas fa-trash"
                  styleClass="p-button-rounded p-button-text"
                  (onClick)="deleteChapter(rowData)"
                  pTooltip="Click to delete chapter"
                  tooltipPosition="top"
                  i18n-pTooltip>
        </p-button>
      </ng-template>
    }
  </p-table>
}